module.exports = __webpack_public_path__ + "static/media/food1.8bb1ea72.jpg";